// extracted by mini-css-extract-plugin
export default {"root":"mIuU2Es6"};